/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import Axios from 'axios';
import { API_URL } from '@config/constants/env';

/* -------------------------------------------------------------------------- */
/*                                    Lib                                     */
/* -------------------------------------------------------------------------- */
export const apiClient = Axios.create({
	withCredentials: true,
	baseURL: API_URL,
});

apiClient.interceptors.request.use(
	(config) => {
		if (config.data instanceof FormData) {
			config.headers['Content-Type'] =
				'multipart/form-data';
		} else {
			config.headers['Content-Type'] = 'application/json';
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

apiClient.interceptors.response.use(
	(response) => {
		return response.data;
	},
	(error) => {
		console.log('Here!', error);
		if (error.code == 'ERR_NETWORK') {
			return Promise.reject({
				status: 'ERR_NETWORK',
				type: 'ERR_NETWORK',
			});
		}
		if (
			error.response.status === 401 &&
			window.location.pathname !== '/login' &&
			window.location.pathname !== '/auth/sign_in' &&
			window.location.pathname !== '/auth/update_password'
		) {
			localStorage.removeItem('user');

			window.location.reload();
		}

		return Promise.reject(error.response.data);
	}
);
